import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { put } from 'helpers/api';
import SaveButton from 'components/form/save_button';

export function SaveChangesButton({ path, viewConfig }) {
  const [saving, setSaving] = useState(false);

  async function handleSave() {
    setSaving(true);
    await put(path, { pipelineViewConfig: viewConfig });
    setSaving(false);
  }

  return (
    <SaveButton
      label="Save Changes"
      labelLocation="right"
      saved={!saving}
      saving={saving}
      onClick={handleSave}
    />
  );
}

SaveChangesButton.propTypes = {
  path: PropTypes.string.isRequired,
  viewConfig: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  path: state.path,
  viewConfig: state.view,
});

export default connect(mapStateToProps)(SaveChangesButton);
